// src/components/DarkMomentTab.js
import React, { useState, useEffect } from 'react';

const DarkMomentTab = ({ data, onChange }) => {
  const [darkMoment, setDarkMoment] = useState(data.darkMoment || '');

  useEffect(() => {
    // Update the local state when the external data changes
    setDarkMoment(data.darkMoment || '');
  }, [data.darkMoment]);

  const handleDarkMomentChange = (e) => {
    const updatedDarkMoment = e.target.value;
    setDarkMoment(updatedDarkMoment);
    onChange({ darkMoment: updatedDarkMoment });
  };


  return (
    <div className='tab-styling'>
      <p className='synopsis-paragraph'>We have come to the moment where all hope is lost. The hero/heroine has faced many things, but this is the worse thing you can throw at them. Don't hold back. But also make sure in this darkest moment that your protagonist sacrifices or gives everything to succeed--or maybe even fail.</p>
      <p className='synopsis-paragraph'>If your book doesn't have a dark moment just leave this section blank. After this, be prepared to wrap up your story with the conclusion. (Your story has an ending, doesn't it?)</p>
      <div className="nice-form-group">
      <label>Dark Moment</label>
      <textarea value={darkMoment} onChange={handleDarkMomentChange} />

      </div>
      <ul className='synopsis-paragraph'>
  <li>Do you describe the problem they face?</li>
  <li>Does the problem conflict them internally and externally?</li>
  <li>As they reach the moment of despair how do they figure out how to solve the problem?</li>
  <li>What is their final choice to solve the problem as the climax occurs?</li>
</ul>
    </div>
  );
};

export default DarkMomentTab;
